<template>
  <div class="ra-product">
    <div class="ra-product__sidebar">
      <div class="product-label">
        <span @click="goHome">
          <i class="ra-icon--arrow-left" />
        </span>
        <p>{{ title }}</p>
      </div>
      <div class="ra-sidebar__menu fadeIn">
        <el-menu :default-active="activeMenu" :router="true">
          <el-menu-item
            v-for="(route, index) in routes"
            :key="index"
            :index="route.name"
            :route="{ name: `${product}.${route.name}` }"
            :class="{ 'is-active': activeMenu === route.name }"
          >
            <i :class="`ra-icon--${route.icon}`"></i>
            <span>{{ route.label }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="ra-product__content">
      <el-container>
        <ra-breadcrumb :routes="breadcrumbRoutes" />
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductLayout",
  data() {
    return {
      activeMenu: "dashboard",
      products: {
        "verify-identity": {
          label: "Verify Identity",
          routes: [
            {
              icon: "pie-chart",
              label: "Overview",
              name: "index",
              activeRoute: true
            },
            {
              icon: "check-circle",
              label: "Verifications",
              name: "verifications",
              activeRoute: true
            }
          ]
        },
        authx: {
          label: "AuthX",
          routes: [
            {
              icon: "code",
              label: "Applications",
              name: "index",
              activeRoute: true
            }
          ]
        }
      }
    };
  },
  computed: {
    product() {
      return this.$route.name.split(".")[0];
    },
    title() {
      return this.products[this.product].label;
    },
    routes() {
      return this.products[this.product].routes;
    },
    breadcrumbRoutes() {
      const { matched } = this.$route;
      let routes = matched.map(route => {
        return {
          path: route.path || null,
          label: route.meta.label
        };
      });
      routes.splice(0, 0, {
        path: "/home",
        label: "Home"
      });
      return routes;
    }
  },
  watch: {
    $route() {
      if (this.$route.path !== null) {
        this.activeMenu = this.$route.name.split(".")[1];
      }
    }
  },
  mounted() {
    if (this.$route.path !== null) {
      this.activeMenu = this.$route.name.split(".")[1];
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home.index" });
    }
  }
};
</script>

<style lang="scss">
$--sidebar: 190px;

.ra-product {
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  &__sidebar {
    width: $--sidebar;
    height: 100%;
    background: var(--ra-product-sidebar);
    padding: 25px 11px 20px;
    z-index: 4;
    position: relative;
    transition: width 0.3s ease-in;

    .product-label {
      display: flex;
      align-items: flex-start;

      p {
        color: #ffffff;
        font-weight: 600;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        line-height: 2;
      }

      span {
        cursor: pointer;
        margin-right: 15px;
        position: relative;
        top: 2px;

        i {
          color: #ffffff;
          font-size: 0.875rem;
        }
      }
    }
  }

  &__content {
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
    width: calc(100% - #{$--sidebar});
    background: #f5f5f5;
    position: relative;

    > .el-container {
      min-height: calc(100vh - 150px);
      height: 100%;
      padding: 30px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.25s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

@media (max-width: 1024px) {
  .ra {
    .ra-sidebar {
      position: absolute;
      left: 0;
      transition: width 0.3s ease-in;
      z-index: 4;

      &.open {
        + .ra-overlay {
          opacity: 1;
          z-index: 3;
          transition: opacity 0.3s ease-out;
        }
      }
    }

    .ra-dashboard--body {
      width: 100% !important;

      &__content {
        padding-left: 130px !important;
      }
    }
  }
}

@media (max-width: 600px) {
  .ra {
    .ra-dashboard--body {
      &__nav {
        .ra-user p {
          display: none;
        }
      }
      &__content {
        padding-left: 100px !important;
        padding-right: 0 !important;
      }
    }
  }
}
</style>
